import { AfterViewInit, Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { DescriptionParser, EMPTY_DESCRIPTION, IParsedDescription } from './description-parser';

@Component({
  selector: 'app-description-text',
  templateUrl: './description-text.component.html',
  styleUrls: ['./description-text.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DescriptionTextComponent implements OnChanges, AfterViewInit {

  @Input() description = '';
  @Input() lengthLimit = 140;
  @Input() parseAsMarkdown = true;
  @Input() checkFromIllumina = false;
  // If true, apply warning style for description
  @Input() isWarning = false;

  public formattedDescription: IParsedDescription = EMPTY_DESCRIPTION;
  public isInPopover = false;
  public displayContent = '';

  private _elementRef: ElementRef;

  constructor(private elementRef: ElementRef) { 
    this._elementRef = elementRef;
  }

  ngAfterViewInit() {
    this.isInPopover = this._elementRef.nativeElement.parentElement == null;
    this.updateDisplayContent();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.description) {
      this.formattedDescription = EMPTY_DESCRIPTION;
    } else if (this.parseAsMarkdown) {
      this.formattedDescription = DescriptionParser.parse(
        this.description, // Raw markdown input
        this.lengthLimit, // Max characters to be included in short content
        this.checkFromIllumina, // if true, only render links of illumina.com domains
        true, // short content for preview should only render links, not other HTML elements,
      );
    } else {
      this.formattedDescription = DescriptionParser.parsePlainText(this.description, this.lengthLimit);
    }
    this.updateDisplayContent();
  }

  private updateDisplayContent(): void {
    if (this.isInPopover && this.formattedDescription.longContent) {
      this.displayContent = this.formattedDescription.longContent;
    } else {
      this.displayContent = this.formattedDescription.shortContent;
    }
  }
}
